<template>

  <div class="alert alert-danger mb-6" role="alert" v-if="validationMessages.length">
    <div class="fw-bold mb-2">Corrija os seguintes campos:</div>
    <ul class="mb-0 ps-4">
      <li v-for="(msg, index) in validationMessages" :key="index">{{ msg }}</li>
    </ul>
  </div>

  <div class="alert alert-danger mb-6" role="alert" v-if="messageError">
    {{ messageError }}
  </div>

  <Steps v-model:activeStep="currentStep" :model="steps" />

  <div class="register-form w-100">
    <form class="form w-100" method="post" @submit.prevent="onSubmit">
      <div v-if="currentStep === 0" class="register-step">
        <div class="register-step__body">
          <div class="row fv-row mb-7">
            <div class="col-xl-6">
              <label class="form-label fw-bolder text-dark fs-6">
                Nome <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.user_name ? 'is-invalid' : ''" v-model="register.user_name"
                     placeholder="Informe o seu nome" name="user_name" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.user_name">
                {{ errors.user_name.join('\n') }}
              </div>
            </div>
            <div class="col-xl-6">
              <label class="form-label fw-bolder text-dark fs-6">
                CPF <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.user_cpf ? 'is-invalid' : ''" v-model="register.user_cpf"
                     v-mask="'###.###.###-##'" placeholder="Informe o seu CPF"
                     name="user_cpf" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.user_cpf">
                {{ errors.user_cpf.join('\n') }}
              </div>
            </div>
          </div>
          <div class="row fv-row mb-7">
            <div class="col-xl-6">
              <label class="form-label fw-bolder text-dark fs-6">
                E-mail <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="email" required
                     :class="errors.user_email ? 'is-invalid' : ''" v-model="register.user_email"
                     :disabled="this.registerParam?.prof_email"
                     placeholder="Informe o seu e-mail" name="user_email" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.user_email">
                {{ errors.user_email.join('\n') }}
              </div>
            </div>
            <div class="col-xl-6">
              <label class="form-label fw-bolder text-dark fs-6">
                Telefone <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.prof_phone ? 'is-invalid' : ''" v-model="register.prof_phone"
                     v-mask="['(##) ####-####', '(##) #####-####']"
                     placeholder="Informe o seu telefone" name="prof_phone" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.prof_phone">
                {{ errors.prof_phone.join('\n') }}
              </div>
            </div>
          </div>

          <div class="mb-10 fv-row row" data-kt-password-meter="true">
            <div class="col-xl-6">
              <div class="mb-1">
                <label class="form-label fw-bolder text-dark fs-6">
                  {{ existingAccount ? 'Senha atual' : 'Senha' }} <span class="text-danger">*</span>
                </label>
                <div class="text-muted fs-7 mb-2" v-if="existingAccount">
                  Este CPF já tem uma conta. Informe a senha atual para criar um novo local. Os dados da conta não serão alterados.
                </div>
                <div class="position-relative mb-3">
                  <input class="form-control form-control-lg form-control-solid" type="password" required
                         :class="errors.user_password ? 'is-invalid' : ''" v-model="register.user_password"
                         placeholder="Informe a sua senha" name="user_password" autocomplete="off"/>

                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.user_password">
                    {{ errors.user_password.join('\n') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6">
              <label class="form-label fw-bolder text-dark fs-6">
                Confirme a senha <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="password" required
                     :class="errors.user_password ? 'is-invalid' : ''" v-model="register.user_password_confirmation"
                     placeholder="Confirme sua senha" name="user_password_confirmation" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.user_password">
                {{ errors.user_password.join('\n') }}
              </div>
            </div>

            <div class="col-xl-12 mt-5" v-if="!this.registerParam?.prof_email">
              <label class="form-label fw-bolder text-dark fs-6">Eu sou<span class="text-danger">*</span></label>
              <Dropdown v-model="register.role" :options="roles" optionLabel="name" optionValue="code"
                        placeholder="Selecione sua função" required @change="onChangeRole"
                        style="display: flex; padding: 0.25rem .75rem"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm">
                <template #option="slotProps">
                  <div class="flex align-items-center text-truncate" style="max-width: 350px;">
                    <div>
                      {{ slotProps.option.name }} <br>
                      <b>{{ slotProps.option.description }}</b>
                    </div>
                  </div>
                </template>
              </Dropdown>
            </div>

            <div v-if="register.role === 'SECRETARY'">
              <div class="row">
                <div class="col-xl-6">
                  <label class="form-label fw-bolder text-dark fs-6">
                    Nome do profissional<span class="text-danger">*</span>
                  </label>
                  <input class="form-control form-control-lg form-control-solid" type="text" required
                         :class="errors.prof_name ? 'is-invalid' : ''" v-model="register.prof_name"
                         placeholder="ex. Dr. João Farias" name="prof_name" autocomplete="off"/>

                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.prof_name">
                    {{ errors.prof_name.join('\n') }}
                  </div>
                </div>
                <div class="col-xl-6">
                  <label class="form-label fw-bolder text-dark fs-6">
                    CPF do profissional<span class="text-danger">*</span>
                  </label>
                  <input class="form-control form-control-lg form-control-solid" type="text" required
                         :class="errors.prof_cpf ? 'is-invalid' : ''" v-model="register.prof_cpf"
                         placeholder="CPF do profissional" name="prof_cpf" autocomplete="off"/>

                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.prof_cpf">
                    {{ errors.prof_cpf.join('\n') }}
                  </div>
                </div>
                <div class="col-xl-6">
                  <label class="form-label fw-bolder text-dark fs-6">
                    E-mail do profissional<span class="text-danger">*</span>
                  </label>
                  <input class="form-control form-control-lg form-control-solid" type="text" required
                         :class="errors.prof_email ? 'is-invalid' : ''" v-model="register.prof_email"
                         placeholder="E-mail do profissional" name="prof_email" autocomplete="off"/>

                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.prof_email">
                    {{ errors.prof_email.join('\n') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fv-row mb-10">
            <label class="form-check form-check-custom form-check-solid form-check-inline">
              <span class="form-check-label fw-bold text-gray-700 fs-6">
                Ao clicar em continuar você concorda com os
                <a target="_blank" href="https://policies.ubbimed.com.br/terms.php" class="ms-1 link-primary">
                  Termos e condições
                </a> da Ubbimed
                 <span class="text-danger">*</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div v-if="currentStep === 1 && !this.registerParam?.prof_email" class="register-step">
        <div class="register-step__body">
          <div class="row fv-row mb-7">
            <div class="col-xl-12">
              <label class="form-label fw-bolder text-dark fs-6" for="place_name">
                Nome do Local de Atendimento <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.place_name ? 'is-invalid' : ''" v-model="register.place_name"
                     id="place_name"
                     placeholder="Ex. Clínica Dr. José" name="place_name" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_name">
                {{ errors.place_name.join('\n') }}
              </div>
            </div>
          </div>

          <div class="row fv-row mb-7">
            <div class="col-12 col-md-4 col-lg-3">
              <label class="form-label fw-bolder text-dark fs-6">
                CEP <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.place_zip_code ? 'is-invalid' : ''" v-model="register.place_zip_code"
                     v-mask="'#####-###'" placeholder="Ex: 00000-000"
                     name="place_zip_code" autocomplete="off" @blur="getZipCode"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_zip_code">
                {{ errors.place_zip_code.join('\n') }}
              </div>
            </div>
          </div>

          <div class="row fv-row mb-7 g-3">
            <div class="col-12 col-md-8">
              <label class="form-label fw-bolder text-dark fs-6" for="place_address">
                Endereço <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.place_address ? 'is-invalid' : ''" v-model="register.place_address"
                     id="place_address"
                     placeholder="Ex. Rua 123" name="place_address" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_address">
                {{ errors.place_address.join('\n') }}
              </div>
            </div>
            <div class="col-12 col-md-4">
              <label class="form-label fw-bolder text-dark fs-6" for="place_addr_numer">
                Número <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.place_addr_numer ? 'is-invalid' : ''" v-model="register.place_addr_numer"
                     id="place_addr_numer"
                     placeholder="Ex. 255" name="place_addr_numer" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_addr_numer">
                {{ errors.place_addr_numer.join('\n') }}
              </div>
            </div>
          </div>

          <div class="row fv-row mb-7 g-3">
            <div class="col-12 col-md-6">
              <label class="form-label fw-bolder text-dark fs-6" for="place_neighborhood">
                Bairro <span class="text-danger">*</span>
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text" required
                     :class="errors.place_neighborhood ? 'is-invalid' : ''" v-model="register.place_neighborhood"
                     id="place_neighborhood"
                     placeholder="Ex. Centro" name="place_neighborhood" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_neighborhood">
                {{ errors.place_neighborhood.join('\n') }}
              </div>
            </div>
            <div class="col-12 col-md-6">
              <label class="form-label fw-bolder text-dark fs-6" for="place_addr_compl">
                Complemento
              </label>
              <input class="form-control form-control-lg form-control-solid" type="text"
                     :class="errors.place_addr_compl ? 'is-invalid' : ''" v-model="register.place_addr_compl"
                     id="place_addr_compl"
                     placeholder="Ex. Apt 10, Andar 9" name="place_addr_compl" autocomplete="off"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_addr_compl">
                {{ errors.place_addr_compl.join('\n') }}
              </div>
            </div>
          </div>

          <div class="row fv-row mb-7 g-3">
            <div class="col-12 col-md-6">
              <label class="form-label fw-bolder text-dark fs-6">
                Estado <span class="text-danger">*</span>
              </label>
              <Dropdown v-model="register.id_state" :options="states" optionLabel="state_name"
                        class="register-dropdown-lg form-control form-control-solid w-100"
                        optionValue="id_state"
                        :class="errors.id_state ? 'is-invalid' : ''"
                        @change="getCitiesFromState($event.value)"
                        :filter="true" placeholder="Selecione o estado"
                        style="display: flex; padding: 0.25rem 0.75rem"/>
              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.id_state">
                {{ errors.id_state.join('\n') }}
              </div>
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label fw-bolder text-dark fs-6">
                Cidade <span class="text-danger">*</span>
              </label>
              <Dropdown v-model="register.id_city" :options="citiesFromState" optionLabel="city_name"
                        class="register-dropdown-lg form-control form-control-solid w-100"
                        optionValue="id_city"
                        :class="errors.id_city ? 'is-invalid' : ''"
                        :filter="true" placeholder="Selecione a cidade"
                        style="display: flex; padding: 0.25rem 0.75rem"/>

              <div class="fv-plugins-message-container invalid-feedback" v-if="errors.id_city">
                {{ errors.id_city.join('\n') }}
              </div>
            </div>
          </div>

          <hr>
          <div class="row fv-row mb-7" v-if="!this.registerParam?.prof_email">
            <div class="col-xl-12 mt-5">
              <label class="form-label fw-bolder text-dark fs-6">
                Como você deseja utilizar a plataforma?<span class="text-danger">*</span>
              </label>
              <Dropdown v-model="register.usage_mode" :options="usageModes" optionLabel="name" optionValue="mode"
                        placeholder="Selecione" required
                        style="display: flex; padding: 0.25rem .75rem"
                        class="form-control form-control-solid w-full md:w-14rem form-control-sm">
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div class="usage-mode-option">
                      <b>{{ slotProps.option.name }} <br></b>
                      <p class="mb-0">{{ slotProps.option.description }}</p>
                    </div>
                  </div>
                </template>
              </Dropdown>
            </div>
          </div>
          <div v-if="register.usage_mode === 'MARKETPLACE'" class="marketplace-pix-section">
            <label class="form-label fw-bolder text-dark fs-6 mb-3 d-block">
              Onde você quer receber os pagamentos?
            </label>
            <div class="row fv-row mb-7 g-3">
              <div class="col-12 col-sm-5 col-lg-4">
                <label class="form-label fw-bolder text-dark fs-6">
                  Tipo de Chave PIX<span class="text-danger">*</span>
                </label>
                <Dropdown v-model="register.place_pix_key_type" :options="pix_key_types"
                          optionLabel="name" optionValue="id"
                          class="register-dropdown-lg form-control form-control-solid w-100"
                          :class="errors.place_pix_key_type ? 'is-invalid' : ''"
                          @change="maskPIXKey($event.value)"
                          :filter="true" placeholder="Tipo de Chave"
                          style="display: flex; padding: 0.25rem 0.75rem"/>
                <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_pix_key_type">
                  {{ errors.place_pix_key_type.join('\n') }}
                </div>
              </div>
              <div class="col-12 col-sm-7 col-lg-8">
                <label class="form-label fw-bolder text-dark fs-6">
                  Chave PIX <span class="text-danger">*</span>
                </label>
                <input v-if="pix_key_mask" class="form-control form-control-lg form-control-solid" type="text" required
                       :class="errors.place_pix_key ? 'is-invalid' : ''"
                       v-model="register.place_pix_key"
                       v-mask="pix_key_mask"
                       placeholder="Informe sua Chave PIX para recebimentos"
                       name="place_pix_key" autocomplete="off"/>

                <input v-if="!pix_key_mask" class="form-control form-control-lg form-control-solid" type="text" required
                       :class="errors.place_pix_key ? 'is-invalid' : ''" v-model="register.place_pix_key"
                       placeholder="Informe sua Chave PIX para recebimentos"
                       name="place_pix_key" autocomplete="off"/>
                <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_pix_key">
                  {{ errors.place_pix_key.join('\n') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="step3" v-if="(currentStep === 2 && (register.role === 'PROFESSIONAL' || register.role === 'SECRETARY')) || (currentStep === 1 && this.registerParam?.prof_email)">
        <div class="container">
          <div class="fv-row mb-5">
            <div class="row">
              <div class="col-xl-12 text-center">
                <b>Selecione a área e especialidade</b>
              </div>

              <div class="col-xl-6">
                <div class="card card-flush h-xl-100">
                  <div class="card-body">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label fw-bolder text-dark">Área</span>
                    </h3>
                    <div class="hover-scroll-overlay-y pe-6 me-n6" style="max-height: 415px">
                      <div class="rounded border-gray-300 border-1 border-gray-300 border-dashed px-7 py-3 mb-6"
                           style="cursor: pointer;" v-for="kind in kinds"
                           @click="loadSpecialtiesFromKind(kind.id_kind)">
                        <div class="d-flex flex-stack mb-3">
                          <div class="me-3">
                            {{ kind.kind_name }}
                            <span class="badge badge-light-info">
                              {{ kind.kind_acronym }}
                            </span>
                          </div>
                        </div>
                        <span class="text-gray-400 fw-bolder"></span>
                        <div class="d-flex flex-stack" v-if="register.kinds.includes(kind.id_kind)">
                          <span class="badge badge-light-success">
                            Selecionado
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-6">
                <div class="card card-flush h-xl-100">
                  <div class="card-body">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label fw-bolder text-dark">Especialidade</span>

                      <input type="text" v-model="searchSpec"
                             class="form-control form-control-sm form-control-solid mt-5 mb-5"
                             placeholder="Pesquisar ...">
                    </h3>
                    <div class="hover-scroll-overlay-y pe-6 me-n6" id="specialties"
                         style="max-height: 415px">
                      <div class="rounded border-gray-300 border-1 border-gray-300 border-dashed px-7 py-3 mb-6"
                           style="cursor: pointer;" v-for="specialty in filteredSpecialties"
                           @click="selectSpecialty(specialty.id_spec)">
                        <div class="d-flex flex-stack mb-3">
                          <div class="me-3">
                            {{ specialty.spec_name }}
                          </div>
                        </div>
                        <span class="text-gray-400 fw-bolder"></span>
                        <div class="d-flex flex-stack" v-if="register.specialties.includes(specialty.id_spec)">
                          <span class="badge badge-light-success">
                            Selecionado
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="actions d-flex justify-content-between">
        <div class="mr-2">
          <button type="button" class="btn btn-lg btn-light-primary ms-5"
                  v-if="currentStep > 0" @click="previousStep">
            <span class="svg-icon svg-icon-4 me-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="6" y="11" width="13" height="2" rx="1" fill="black"/>
                <path d="M8.56569 11.4343L12.75 7.25C13.1642 6.83579 13.1642 6.16421 12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75L5.70711 11.2929C5.31658 11.6834 5.31658 12.3166 5.70711 12.7071L11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25C13.1642 17.8358 13.1642 17.1642 12.75 16.75L8.56569 12.5657C8.25327 12.2533 8.25327 11.7467 8.56569 11.4343Z" fill="black"/>
              </svg>
            </span>
            Voltar
          </button>
        </div>
        <div class="mr-2">
          <button type="button" class="btn btn-lg btn-primary mx-5"
                  @click="nextStep" v-if="this.steps.length - 1 > currentStep">
            Continuar
            <span class="svg-icon svg-icon-4 ms-1 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black"/>
                  <path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black"/>
                </svg>
              </span>
          </button>
          <button type="submit" class="btn btn-lg btn-primary mx-5" v-if="(this.steps.length - 1) === currentStep">
              <span class="indicator-label">Finalizar
                <span class="svg-icon svg-icon-3 ms-2 me-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="18" y="13" width="13" height="2" rx="1" transform="rotate(-180 18 13)" fill="black"/>
                    <path d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z" fill="black"/>
                  </svg>
                </span>
              </span>
          </button>
        </div>
      </div>
    </form>
    <br>
  </div>
</template>

<script>
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primevue/resources/themes/bootstrap4-light-blue/theme.css';
import 'primeicons/primeicons.css';
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import {mask} from "vue-the-mask";
import Dropdown from 'primevue/dropdown';
import Steps from 'primevue/steps';

export default {
  name: "StepperRegister",
  props: {
    registerParam: Object,
  },
  emits: ['onRegister'],
  directives: {
    mask,
  },
  components: {
    Dropdown, Steps
  },
  data() {
    return {
      submitted: false,
      roles: [
        {name: 'Profissional da saúde', code: 'PROFESSIONAL', description: 'Ex. Médico, Psicólogo, Nutricionista'},
        {name: 'Secretária', code: 'SECRETARY', description: 'Secretária do profissional da saúde'},
        {name: 'Administrador', code: 'ADMIN', description: 'Administrador ou Responsável legal'},
      ],
      usageModes: [
        {name: 'Vender no marketplace', mode: 'MARKETPLACE', description: 'Ex. Vender consultas, exames, vacinas, etc.'},
        {name: 'Gerenciar minha clínica', mode: 'ON_PREMISE', description: 'Ex. Gerenciar minha clínica'},
      ],
      searchSpec: '',
      searchInsurance: '',
      existingAccount: false,
      cpfLookupId: 0,
      errors: {},
      messageError: '',
      kinds: [],
      specialties: [],
      states: [],
      citiesFromState: [],
      pix_key_types: [],
      pix_key_mask: '',
      currentStep: 0,
      steps: [
        {label: 'Dados'},
        {label: 'Local'},
        {label: 'Especialidades'},
      ],
      register: {
        role: '',
        user_name: '',
        user_cpf: '',
        user_email: '',
        prof_name: '',
        prof_email: '',
        user_password: '',
        user_password_confirmation: '',
        prof_cpf: '',
        prof_phone: '',
        term_conditions: true,
        place_name: '',
        place_address: '',
        place_addr_numer: '',
        place_addr_compl: '',
        place_neighborhood: '',
        id_state: '',
        id_city: '',
        specialties: [],
        kinds: [],
        prof_council: '',
        usage_mode: '',
        place_zip_code: '',
        place_pix_key: '',
        place_pix_key_type: '',
      }
    }
  },
  created() {
    this.loadKinds();
    this.getStates();
    this.getPixKeyTypes();
  },
  computed: {
    filteredSpecialties() {
      return this.specialties.filter(specialty => {
        return specialty.spec_name.toLowerCase().includes(this.searchSpec.toLowerCase())
      })
    },
    validationMessages() {
      return this.flattenValidationErrors(this.errors);
    },
  },
  watch: {
    'register.user_cpf'(value) {
      this.lookupExistingAccount(value);
    },
    registerParam: {
      handler(newVal) {
        if (newVal) {
          this.loadRegisterParams();
        }
      },
      immediate: true,
      deep: true
    }
  },
  async mounted() {
    this.loadRegisterParams();
  },
  methods: {
    lookupExistingAccount(value) {
      const cpf = (value || '').replace(/\D/g, '');
      if (cpf.length !== 11) {
        this.existingAccount = false;
        return;
      }

      const requestId = ++this.cpfLookupId;
      http.get('/professionals/has-register', {params: {cpf}}).then((response) => {
        if (requestId !== this.cpfLookupId) {
          return;
        }

        const data = response.data || {};
        this.existingAccount = !!(data.exists && (data.is_professional || data.has_place));
      }).catch(() => {
        if (requestId === this.cpfLookupId) {
          this.existingAccount = false;
        }
      });
    },
    loadRegisterParams() {
      this.register.prof_email = this.registerParam?.prof_email ?? '';
      this.register.user_email = this.registerParam?.user_email ?? this.register.prof_email;
      this.register.user_name = this.registerParam?.user_name ?? '';
      this.register.user_cpf = this.registerParam?.user_cpf ?? '';
      this.register.prof_phone = this.registerParam?.user_phone ?? '';
      if (this.registerParam?.usage_mode) {
        this.register.usage_mode = this.registerParam.usage_mode;
      } else {
        this.register.usage_mode = this.registerParam?.prof_email ? 'ON_PREMISE' : '';
      }
      this.register.role = this.registerParam?.prof_email ? 'PROFESSIONAL' : '';
      this.steps = [
        {label: 'Dados'},
        {label: 'Especialidades'},
      ];
    },
    onChangeRole() {
      if (this.register.role === 'PROFESSIONAL' || this.register.role === 'SECRETARY') {
        this.steps = [
          {label: 'Dados'},
          {label: 'Local'},
          {label: 'Especialidades'},
        ];
      } else {
        this.steps = [
          {label: 'Dados'},
          {label: 'Local'},
        ];
      }
    },
    getStates() {
      http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(stateId) {
      return http.get(`/states/${stateId}/cities`).then((response) => {
        this.citiesFromState = response.data;

        return response;
      });
    },
    getPixKeyTypes() {
      http.get(`/pixkeytypes`).then((response) => {
        this.pix_key_types = response.data;
      });
    },
    selectSpecialty(specialtyId) {
      let index = this.register.specialties.indexOf(specialtyId);
      if (index === -1) {
        this.register.specialties.push(specialtyId);
      } else {
        this.register.specialties.splice(index, 1);
      }
    },
    loadSpecialtiesFromKind(kindId) {
      this.register.kinds = [];
      this.register.kinds.push(kindId);

      http.get(`kinds/${kindId}/specialties`).then((response) => {
        this.specialties = response.data;
      })
    },
    loadKinds() {
      http.get(`kinds?without_exams=false`).then((response) => {
        this.kinds = response.data;
      })
    },
    getZipCode() {
      http.get(`zipcode/` + this.register.place_zip_code).then((response) => {
        this.register.place_address = response.data.address;
        this.register.place_neighborhood = response.data.neighborhood;
        this.register.id_state = response.data.state?.id_state;
        this.getCitiesFromState(this.register.id_state);
        this.register.id_city = response.data.city?.id_city;
      }).catch((e) => {
        console.log(e.response)
      });
    },
    maskPIXKey(keyPixType) {
      switch (keyPixType) {
        case 'CPF':
          this.pix_key_mask = '###.###.###-##';
          break;
        case 'CNPJ':
          this.pix_key_mask = '##.###.###/####-##';
          break;
        case 'PHONE':
          this.pix_key_mask = '(##) #####-####';
          break;
        case 'EMAIL':
          this.pix_key_mask = ''
          break;
        default:
          this.pix_key_mask = '';
          break;
      }
    },
    validateStep() {
      let step = this.currentStep;
      if (step === 0) {
        if (!this.register.user_cpf || !this.register.user_email ||
          !this.register.user_name || !this.register.prof_phone ||
          !this.register.user_password || !this.register.user_password_confirmation ||
          !this.register.term_conditions || !this.register.role ||
          (this.register.role === 'SECRETARY' && (!this.register.prof_name || !this.register.prof_cpf || !this.register.prof_email))) {

          console.log(this.register);

          Swal.fire({
            text: "Informe todos os dados.",
            icon: "error",
          });

          return false;
        }

        if (this.register.user_password.length < 6) {
          Swal.fire({
            text: "A senha deve ter no mínimo 6 caracteres.",
            icon: "error",
          });

          return false;
        }

        if (this.register.user_password !== this.register.user_password_confirmation) {
          Swal.fire({
            text: "As senhas devem ser iguais.",
            icon: "error",
          });

          return false;
        }

        return true;
      } else if (step === 1 && !this.registerParam?.prof_email) {
        if (!this.register.id_city || !this.register.id_state || !this.register.place_name || !this.register.usage_mode || (this.register.usage_mode === 'MARKETPLACE' && (!this.register.place_pix_key || !this.register.place_pix_key_type))) {

          console.log(this.register)
          Swal.fire({
            text: "Informe todos os dados do local.",
            icon: "error",
          });

          return false;
        }

        return true;
      }

      return true;
    },
    nextStep() {
      if (this.currentStep < this.steps.length - 1) {
        if (!this.validateStep()) {
          return;
        }

        this.errors = {};
        this.messageError = '';
        this.currentStep++;
      }
    },
    previousStep() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
    },
    flattenValidationErrors(errors) {
      if (!errors || typeof errors !== 'object' || Array.isArray(errors)) {
        return [];
      }

      return Object.values(errors).flat().filter(Boolean);
    },
    resolveApiErrorMessage(data, fallback = 'Não foi possível concluir o cadastro.') {
      if (typeof data === 'string' && data.trim() !== '') {
        return data;
      }

      if (data?.message && typeof data.message === 'string') {
        return data.message;
      }

      const fromErrors = this.flattenValidationErrors(data?.errors);
      if (fromErrors.length > 0) {
        return fromErrors.join('<br>');
      }

      return fallback;
    },
    getStepIndexForField(field) {
      const dadosFields = [
        'user_name', 'user_cpf', 'user_email', 'prof_phone', 'user_password',
        'user_password_confirmation', 'role', 'prof_name', 'prof_cpf', 'prof_email',
      ];
      const localFields = [
        'place_name', 'place_zip_code', 'place_address', 'place_addr_numer',
        'place_neighborhood', 'place_addr_compl', 'id_state', 'id_city', 'usage_mode',
        'place_pix_key_type', 'place_pix_key',
      ];
      const specialtyFields = ['kinds', 'specialties', 'prof_council'];

      if (dadosFields.includes(field)) {
        return 0;
      }

      const localStepIndex = this.steps.findIndex((step) => step.label === 'Local');
      if (localFields.includes(field) && localStepIndex >= 0) {
        return localStepIndex;
      }

      const specialtyStepIndex = this.steps.findIndex((step) => step.label === 'Especialidades');
      if (specialtyFields.includes(field) && specialtyStepIndex >= 0) {
        return specialtyStepIndex;
      }

      return 0;
    },
    focusStepOnValidationErrors(errors) {
      const fields = Object.keys(errors || {});
      if (fields.length === 0) {
        return;
      }

      const targetStep = fields.reduce((minStep, field) => {
        return Math.min(minStep, this.getStepIndexForField(field));
      }, Number.POSITIVE_INFINITY);

      if (targetStep !== Number.POSITIVE_INFINITY) {
        this.currentStep = targetStep;
      }
    },
    handleRegisterApiError(error) {
      const response = error?.response;
      if (!response) {
        this.messageError = 'Não foi possível conectar ao servidor. Tente novamente.';
        Alert.error(this.messageError);
        return;
      }

      const {data, status} = response;

      if (status === 422) {
        if (data?.errors && typeof data.errors === 'object') {
          this.errors = data.errors;
          this.messageError = '';
          this.focusStepOnValidationErrors(data.errors);
          Alert.error(this.resolveApiErrorMessage(data, 'Revise os dados informados.'), 'Dados inválidos');
          this.$nextTick(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
          });
          return;
        }

        this.errors = {};
        this.messageError = this.resolveApiErrorMessage(data, 'Dados inválidos.');
        Alert.error(this.messageError, 'Dados inválidos');
        this.$nextTick(() => {
          window.scrollTo({top: 0, behavior: 'smooth'});
        });
        return;
      }

      this.errors = {};
      this.messageError = this.resolveApiErrorMessage(data);
      Alert.error(this.messageError);
      this.$nextTick(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
      });
    },
    async onSubmit() {
      this.messageError = '';
      this.errors = {};

      if (this.register.role === 'PROFESSIONAL' || this.register.role === 'SECRETARY') {
        if (this.register.kinds.length <= 0 || this.register.specialties.length <= 0) {
          Swal.fire({
            text: "Informe a área e a especialidade.",
            icon: "error",
          });

          return;
        }

        if (!this.register.prof_council) {
          let kind = this.kinds.find((k) => k.id_kind === this.register.kinds[0]);
          const {value: profCouncil} = await Swal.fire({
            title: 'Qual o número do ' + kind.kind_acronym,
            input: 'text',
            inputLabel: 'Informe o seu ' + kind.kind_acronym,
            showCancelButton: false,
            allowOutsideClick: false,
            inputValue: this.register.prof_council,
            confirmButtonColor: '#009ef7',
            confirmButtonText: "Avançar <i class='bi bi-arrow-right-short text-white'></i>",
            inputValidator: (value) => {
              if (!value) {
                return 'Você precisa informar o número do ' + kind.kind_acronym
              }
            }
          });

          this.register.prof_council = profCouncil;
        }
      }

      http.post(`/professionals/register`, this.register).then((response) => {
        this.$store.commit('auth/setUser', response.data.user);
        this.$store.commit('auth/setToken', response.data.token);

        this.$store.dispatch('auth/loadPlaces', response.data.user).then(() => {
          this.$emit('onRegister');
        });
      }).catch((error) => {
        this.handleRegisterApiError(error);
      }).finally(() => {
        this.submitted = false;
      });
    },
  }
}
</script>

<style scoped>
.register-form,
.register-step__body {
  width: 100%;
  max-width: 100%;
}

.marketplace-pix-section > .form-label {
  line-height: 1.45;
  white-space: normal;
}

.usage-mode-option {
  max-width: 100%;
  white-space: normal;
}

.form-control-custom {
  display: flex;
}

:deep(.p-steps) {
  width: 100%;
  max-width: 100%;
}

/* Mesma altura visual dos inputs form-control-lg da aba Local */
:deep(.register-dropdown-lg.p-dropdown) {
  width: 100%;
  min-height: calc(1.5em + 1.65rem + 2px);
  align-items: center;
}

:deep(.register-dropdown-lg.p-dropdown .p-dropdown-label) {
  padding: 0;
  line-height: 1.5;
}

:deep(.register-dropdown-lg.p-dropdown .p-dropdown-trigger) {
  width: 2.25rem;
}
</style>